module.exports = __webpack_public_path__ + "images/media-kit-a0f38208e9f9e948b02e352344fb5f6b.svg";